import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['selectInput', 'editButton'];

  declare selectInputTarget: HTMLInputElement;
  declare editButtonTarget: HTMLButtonElement;

  public changeSelectedOrganization (event: Event) {
    const orgId = this.selectInputTarget.value;
    const adminLink = document.querySelector('#edit_org_link') as HTMLAnchorElement;
    const primaryContactLink = document.querySelector('#election_primary_contact > a') as HTMLAnchorElement;
    const orgLocationLink = document.querySelector('.organization-location > a') as HTMLAnchorElement;

    this.updateLinkHref(this.editButtonTarget, orgId);
    this.updateLinkHref(adminLink, orgId);
    this.updateLinkHref(primaryContactLink, orgId);
    this.updateLinkHref(orgLocationLink, orgId);

    this.syncTimeZone();

    // Update Current.organization on the backend
    this.updateCurrentOrganization(orgId);
  }

  private syncTimeZone(): void {
    if (this.element.getAttribute('data-new-record') !== 'true') return;

    const timeZone = this.selectInputTarget.selectedOptions[0]?.dataset.timezone;
    const timeZoneSelect = document.querySelector('select#election_timezone') as HTMLSelectElement | null;
    if (!timeZone || !timeZoneSelect) return;

    const hasOption = Array.from(timeZoneSelect.options).some((option) => option.value === timeZone);
    if (!hasOption) return;

    timeZoneSelect.value = timeZone;
    timeZoneSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }

  private updateCurrentOrganization(organizationId: string): void {
    if (!organizationId) return;

    // Only refresh date formats if using calendar duration type
    const durationType = this.getElectionDurationType();
    if (durationType !== 'calendar_range') {
      return; // Skip refresh for timer mode
    }

    // Get current start_date and end_date values
    const startDateInput = document.querySelector('input[name="election[start_date]"]') as HTMLInputElement;
    const endDateInput = document.querySelector('input[name="election[end_date]"]') as HTMLInputElement;

    const params = new URLSearchParams({
      organization_id: organizationId,
      start_date: startDateInput?.value || '',
      end_date: endDateInput?.value || '',
      duration_type: durationType || ''
    });

    const url = `/elections/refresh_date_formats?${params.toString()}`;

    // Use Turbo to refresh the voting_time_form frame
    const frame = document.getElementById('voting_time_form') as HTMLElement;
    if (frame && 'src' in frame) {
      frame.dataset.orgRefreshed = 'true';
      (frame as any).src = url;
    }
  }

  private getElectionDurationType(): string | null {
    // Check which radio button is selected for duration_type
    const selectedRadio = document.querySelector('input[name="election[duration_type]"]:checked') as HTMLInputElement;
    return selectedRadio?.value || null;
  }

  private updateLinkHref(selector: string, orgId: string) {
    if (selector) {
      let url = selector.getAttribute('href');
      url = url.replace(/\d+/, orgId);
      selector.setAttribute('href', url);
    }
  }
}
